<div class="manage-entity-shell">
  @if (mobileSidebarOpen) {
    <button
      type="button"
      class="manage-entity-shell__backdrop"
      aria-label="Close sidebar"
      (click)="closeMobileSidebar()"
    ></button>
  }

  <aside
    class="manage-entity-shell__sidebar"
    [class.manage-entity-shell__sidebar--collapsed]="sidebarCollapsed"
    [class.manage-entity-shell__sidebar--mobile-open]="mobileSidebarOpen"
  >
    <app-dashboard-sidebar [collapsed]="sidebarCollapsed"/>
  </aside>

  <div class="manage-entity-shell__content">
    <app-dashboard-header
      [title]="''"
      [subtitle]="''"
      [user]="user"
      [currentTime]="''"
      (menuToggle)="handleMenuToggle()"
    />

    <main class="manage-entity-page">
      <section class="manage-entity-page__panel app-card">
        <div class="manage-entity-page__panel-header">
          <div class="manage-entity-page__heading-copy">
            <h2 class="app-title-serif">Manage Developer Name</h2>
          </div>

          <button type="button" class="app-button app-button--primary manage-entity-page__add-button" (click)="openAddEntityModal()">
            <span class="manage-entity-page__add-icon">+</span>
            <span>Add New Developer</span>
          </button>
        </div>

        <div class="manage-entity-page__panel-body">
          <form class="manage-entity-filters" [formGroup]="filterForm">
            <label class="app-form-field manage-entity-filters__field">
              <span class="app-form-label">Search</span>
              <div class="manage-entity-filters__search">
                <span class="manage-entity-filters__search-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="7"></circle>
                    <path d="m20 20-3.5-3.5"></path>
                  </svg>
                </span>
                <input class="app-form-input manage-entity-filters__search-input" type="text" placeholder="Search" formControlName="search" />
              </div>
            </label>


            <div class="manage-entity-filters__clear">
              <button
                type="button"
                class="app-button app-button--secondary equal app-filter-actions__button"
                [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                (click)="clearFilters()"
              >
                Clear
              </button>
            </div>

            <div class="manage-entity-filters__actions">
              <button
                type="button"
                class="app-button app-button--secondary manage-entity-filters__menu-button app-action-menu-trigger"
                [class.manage-entity-filters__menu-button--open]="isEntityActionMenuOpen"
                [class.app-action-menu-trigger--open]="isEntityActionMenuOpen"
                [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                (click)="toggleEntityActionMenu()"
                aria-label="Open entity actions"
              >
                <svg class="manage-entity-filters__menu-icon app-action-menu-trigger__icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <circle cx="12" cy="5.5" r="1.5"></circle>
                  <circle cx="12" cy="12" r="1.5"></circle>
                  <circle cx="12" cy="18.5" r="1.5"></circle>
                </svg>
              </button>

              @if (isEntityActionMenuOpen) {
                <div class="manage-entity-filters__menu app-action-menu-panel">
                  <button
                    type="button"
                    class="app-button app-button--secondary manage-entity-filters__menu-item app-action-menu-item"
                    title="Export Data"
                    aria-label="Export Data"
                    [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                    (click)="handleExportEntities()"
                  >
                    <span class="app-action-menu-item__icon" aria-hidden="true">
                      <i class="fa-solid fa-file-export" aria-hidden="true"></i>
                    </span>
                  </button>

                  <button
                    type="button"
                    class="app-button app-button--secondary manage-entity-filters__menu-item app-action-menu-item"
                    title="Download Template"
                    aria-label="Download Template"
                    [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                    (click)="handleDownloadTemplate()"
                  >
                    <span class="app-action-menu-item__icon" aria-hidden="true">
                      <i class="fa-solid fa-download" aria-hidden="true"></i>
                    </span>
                  </button>

                  <button
                    type="button"
                    class="app-button app-button--primary manage-entity-filters__menu-item app-action-menu-item"
                    title="Import Data"
                    aria-label="Import Data"
                    [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                    (click)="triggerEntityImportFilePicker(entityImportInput)"
                  >
                    <span class="app-action-menu-item__icon" aria-hidden="true">
                      <i class="fa-solid fa-file-import" aria-hidden="true"></i>
                    </span>
                  </button>
                </div>
              }

              <input
                #entityImportInput
                type="file"
                class="manage-entity-filters__import-input"
                accept=".xlsx"
                (change)="onEntityImportFileSelected($event)"
              />
            </div>
          </form>

          <div class="manage-entity-page__table-wrap app-table-scroll">
            <table class="manage-entity-table">
              <thead>
                <tr>
                <th>S.No.</th>
<th><button type="button" class="manage-sort-button" (click)="toggleSort('entity_name')" [attr.aria-label]="'Sort by Developer Name'"><span>Developer Name</span><svg class="manage-sort-icon" [class.manage-sort-icon--ascending]="isSortAscending('entity_name')" [class.manage-sort-icon--descending]="isSortDescending('entity_name')" viewBox="0 0 12 16" aria-hidden="true"><path class="manage-sort-icon-up" d="M6 1 2 5h8L6 1Z"></path><path class="manage-sort-icon-down" d="m2 11 4 4 4-4H2Z"></path></svg></button></th>
<th><button type="button" class="manage-sort-button" (click)="toggleSort('entity_type')" [attr.aria-label]="'Sort by Developer Type'"><span>Developer Type</span><svg class="manage-sort-icon" [class.manage-sort-icon--ascending]="isSortAscending('entity_type')" [class.manage-sort-icon--descending]="isSortDescending('entity_type')" viewBox="0 0 12 16" aria-hidden="true"><path class="manage-sort-icon-up" d="M6 1 2 5h8L6 1Z"></path><path class="manage-sort-icon-down" d="m2 11 4 4 4-4H2Z"></path></svg></button></th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @if (isLoading) {
                  <tr>
                    <td colspan="5" class="manage-entity-page__empty-state">Loading entities...</td>
                  </tr>
                } @else if (filteredEntities.length) {
                  @for (item of filteredEntities; track trackByEntityId($index, item)) {
                    <tr>
                    <td>{{ item.serial_no }}</td>
                      <td>{{ item.entity_name }}</td>
                      <td>{{ item.entity_type }}</td>
                      <td>
                        <span class="app-pill" [class.app-pill--success]="item.status === 'ACTIVE'" [class.app-pill--muted]="item.status !== 'ACTIVE'">
                          {{ item.status || '-' }}
                        </span>
                      </td>
                      <td>
                        <div class="manage-entity-page__actions">
                          <div class="app-row-action-menu">
                            <details class="app-row-action-menu__details">
                              <summary class="app-row-action-menu__toggle" aria-label="Open entity actions">
                                <span class="app-row-action-menu__dots" aria-hidden="true">
                                  <span></span>
                                  <span></span>
                                  <span></span>
                                </span>
                            </summary>
                            <div class="app-row-action-menu__dropdown">
                                <button type="button" class="app-row-action-menu__item app-row-action-menu__item--view" (click)="openViewEntityModal(item)">
                                  <span class="app-row-action-menu__icon app-row-action-menu__icon--view" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="M2.5 12s3.5-6.5 9.5-6.5S21.5 12 21.5 12s-3.5 6.5-9.5 6.5S2.5 12 2.5 12Z"></path>
                                      <circle cx="12" cy="12" r="2.8"></circle>
                                    </svg>
                                  </span>
                                  <span>View</span>
                                </button>
                                <button type="button" class="app-row-action-menu__item app-row-action-menu__item--edit" (click)="openEditEntityModal(item)">
                                  <span class="app-row-action-menu__icon app-row-action-menu__icon--edit" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="m4 20 4.5-1 11-11a2.1 2.1 0 0 0-3-3l-11 11L4 20Z"></path>
                                      <path d="m13.5 6.5 4 4"></path>
                                    </svg>
                                  </span>
                                  <span>Edit</span>
                                </button>
                                <button type="button" class="app-row-action-menu__item app-row-action-menu__item--danger app-row-action-menu__item--delete" (click)="openDeleteEntityModal(item)">
                                  <span class="app-row-action-menu__icon app-row-action-menu__icon--delete" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="M3 6h18"></path>
                                      <path d="M8 6V4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6"></path>
                                      <path d="M6 6l1 14a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 18 20L19 6"></path>
                                      <path d="M10 10v6"></path>
                                      <path d="M14 10v6"></path>
                                    </svg>
                                  </span>
                                  <span>Delete</span>
                                </button>
                              </div>
                            </details>
                          </div>
                        </div>
                      </td>
                    </tr>
                  }
                } @else {
                  <tr>
                    <td colspan="5" class="manage-entity-page__empty-state">No entities found</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          @if (canShowPagination()) {
            <div class="manage-entity-page__pagination">
              <div class="manage-entity-page__pagination-summary">
                <span>{{ getPaginationLabel() }}</span>
              </div>

              <div class="manage-entity-page__pagination-actions">
                <button type="button" class="app-button app-button--secondary manage-entity-page__pagination-button" [disabled]="pagination.page_no <= 1 || isLoading" (click)="goToPreviousPage()">
                  Previous
                </button>
                <div class="manage-entity-page__pagination-pages" aria-label="Pagination pages">
                  @for (page of getPaginationItems(); track $index) {
                    @if (page === -1) {
                      <span class="manage-entity-page__pagination-ellipsis" aria-hidden="true">...</span>
                    } @else {
                      <button type="button" class="manage-entity-page__pagination-page" [class.manage-entity-page__pagination-page--active]="pagination.page_no === page" [disabled]="isLoading" (click)="goToPage(page)">{{ page }}</button>
                    }
                  }
                </div>
                <button type="button" class="app-button app-button--secondary manage-entity-page__pagination-button" [disabled]="pagination.page_no >= pagination.total_pages || isLoading || pagination.total_pages === 0" (click)="goToNextPage()">
                  Next
                </button>
              </div>

              <label class="manage-entity-page__pagination-size">
                <span class="manage-entity-page__pagination-size-label">Rows per page</span>
                <select class="app-form-select manage-entity-page__pagination-select" [formControl]="pageSizeControl">
                  @for (size of pageSizeOptions; track size) {
                    <option [ngValue]="size">{{ size }}/Page</option>
                  }
                </select>
              </label>
            </div>
          }
        </div>
      </section>
    </main>
  </div>

  @if (entityModalOpen) {
    <div class="app-modal-backdrop">
      <dialog class="app-modal manage-entity-modal" open>
        <div class="manage-entity-modal__header">
          <div>
            <h3 class="app-title-serif">{{ modalMode === 'edit' ? 'Edit Developer' : modalMode === 'view' ? 'View Developer' : 'Add New Developer' }}</h3>
          </div>

          <button type="button" class="app-button app-button--icon manage-entity-modal__close" aria-label="Close modal" (click)="closeEntityModal()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round">
              <path d="M6 6 18 18"></path>
              <path d="M18 6 6 18"></path>
            </svg>
          </button>
        </div>

        <form [formGroup]="entityForm" (ngSubmit)="saveEntity()">
          <div class="manage-entity-modal__body">
            <div class="manage-entity-modal__grid">
              <label class="app-form-field">
                <span class="app-form-label">Developer Name <span class="manage-entity-modal__required">*</span></span>
                <input class="app-form-input" type="text" placeholder="Developer name" formControlName="entity_name" (blur)="trimDeveloperName()" />
                @if (isRequiredFieldInvalid('entity_name')) {
                  <section class="app-form-error">Developer name is required</section>
                }
                @if (isDeveloperNameAlphabeticInvalid()) {
                  <section class="app-form-error">Developer name must contain at least one alphabetic character</section>
                }
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Developer Type <span class="manage-entity-modal__required">*</span></span>
                <select class="app-form-select" formControlName="entity_type">
                  <option value="" disabled>Select Type</option>
                  @for (type of entityTypeOptions; track type) {
                    <option [value]="type">{{ type }}</option>
                  }
                </select>
                @if (isRequiredFieldInvalid('entity_type')) {
                  <section class="app-form-error">Developer type is required</section>
                }
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Status</span>
                <input class="app-form-input" type="text" placeholder="ACTIVE / INACTIVE" formControlName="status" />
              </label>
            </div>
          </div>

          <div class="manage-entity-modal__footer">
            <button type="button" class="app-button app-button--secondary" (click)="closeEntityModal()">Cancel</button>
            @if (modalMode !== 'view') {
              <button type="submit" class="app-button app-button--primary">Save</button>
            }
          </div>
        </form>
      </dialog>
    </div>
  }

  @if (deleteModalOpen && selectedEntity) {
    <div class="app-modal-backdrop">
      <section class="app-modal app-modal--compact manage-entity-delete">
        <div class="manage-entity-delete__header">
          <div class="manage-entity-delete__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M10 11v5"></path>
              <path d="M14 11v5"></path>
              <path d="M3 6h18"></path>
              <path d="M8 6V4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6"></path>
              <path d="M6 6l1 14a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 18 20L19 6"></path>
            </svg>
          </div>
          <div>
            <h3 class="app-title-serif">Delete Developer</h3>
            <p>This action will remove the entity</p>
          </div>
        </div>

        <p class="manage-entity-delete__copy">
          Are you sure you want to delete <strong>{{ selectedEntity.entity_name }}</strong>?
        </p>

        <div class="manage-entity-delete__footer">
          <button type="button" class="app-button app-button--secondary" (click)="closeDeleteModal()">Cancel</button>
          <button type="button" class="app-button app-button--danger" (click)="confirmDelete()">Confirm Delete</button>
        </div>
      </section>
    </div>
  }
</div>
